import { useId } from 'react';
import { Link } from 'react-router-dom';

export function ProfileDataExplainer() {
  const titleId = useId();

  return <section className="panel profile-data-explainer" aria-labelledby={titleId}>
    <h2 id={titleId}>Como interpretar os dados deste perfil</h2>
    <p>Cada seção tem fonte e período de cobertura próprios. Uma seção sem registros pode indicar dado não publicado, ainda não coletado ou período sem cobertura; isso não equivale automaticamente a zero.</p>
    <p>Despesas da Câmara usam o valor líquido informado no CEAP; no Senado, o valor reembolsado do CEAPS. A média mensal considera os dias de exercício identificados e não mede eficiência. Proposições e votos nominais registrados são contagens, não medidas de qualidade ou de presença.</p>
    <p>Votações secretas não permitem identificar a posição individual. A ausência de voto nominal registrado também não prova ausência na sessão.</p>
    <div><Link to="/metodologia">Leia as definições completas</Link><span aria-hidden="true">·</span><Link to="/fontes">Consulte as fontes oficiais</Link></div>
  </section>;
}
